/**
 * Pre-compiled fr-FR messages for PasswordInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  hide: `Masquer le mot de passe`,
  show: `Afficher le mot de passe`,
};
